import mutations from './synlabPriceList.mutations'
import actions from './synlabPriceList.actions'
import getters from './synlabPriceList.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
